import { useState } from "react";
import Modal from "../../../modal/Modal";
import { getTranslatedTextSelector } from "../../../../redux/slices/translatedText/getTranslatedText";
import DashboardImage from "../../../../assets/images/dashboard-image.svg";

import "./styles.css";
import { useSelector } from "react-redux";
import OTPPopup from "../OTPInput/OTPPopup";

const ProceedToSignupModal = (props) => {
  const {
    show,
    setShow,
    handleLoginWithOtp,
    handleLoginWithOTPOnCall,
    authentication,
  } = props;

  const getTranslateText = useSelector(getTranslatedTextSelector);
  const [showOtpPopup, setShowOtpPopup] = useState(false);

  const handleCancel = () => {
    setShow(false);
  };

  const handleOtpOnWhatsapp = () => {
    setShowOtpPopup(false);
    handleLoginWithOtp("New");
  };

  const handleOtpOnCall = () => {
    setShowOtpPopup(false);
    handleLoginWithOTPOnCall("New");
  };

  const handleProceedToSignup = () => {
    setShow(false);
    handleLoginWithOtp("New");
  };

  return (
    <>
      <Modal visible={show}>
        <div className="wrapper">
          <img src={DashboardImage} alt="" className="w-[40px] m-auto" />
          <p className="welcome-text">
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item.pageKey === "welcome_txt"
                )[0]?.keyValue
                ? getTranslateText?.data?.filter(
                    (item) => item.pageKey === "welcome_txt"
                  )[0]?.keyValue
                : "Welcome"
              : "Welcome"}
          </p>

          <p className="welcome-details">
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item.pageKey === "key_register_proceed"
                )[0]?.keyValue
                ? getTranslateText?.data?.filter(
                    (item) => item.pageKey === "key_register_proceed"
                  )[0]?.keyValue
                : " Seems like you are not registered with us , please proceed to signup "
              : " Seems like you are not registered with us , please proceed to signup "}
            <span className="mobile-number">({authentication.userName})</span>{" "}
          </p>

          <div className="button-container">
            <button type="button" onClick={handleCancel} className="cancel-btn">
              {getTranslateText?.data?.length > 0
                ? getTranslateText?.data?.filter(
                    (item) => item.pageKey === "label_cancel"
                  )[0]?.keyValue
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "label_cancel"
                    )[0]?.keyValue
                  : "Cancel"
                : "Cancel btn_proceed"}
            </button>
            <button
              type="button"
              //onClick={handleProceedToSignup}
              onClick={() => {
                setShowOtpPopup(true);
                setShow(false);
              }}
              className="proceed-btn"
            >
              {getTranslateText?.data?.length > 0
                ? getTranslateText?.data?.filter(
                    (item) => item.pageKey === "btn_proceed"
                  )[0]?.keyValue
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "btn_proceed"
                    )[0]?.keyValue
                  : "Proceed"
                : "Proceed"}
            </button>
          </div>
        </div>
      </Modal>
      <>
        <OTPPopup
          visible={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          handleOtpCall={handleOtpOnCall}
          handleOtpWhatsapp={handleOtpOnWhatsapp}
          getTranslateText={getTranslateText}
        />
      </>
    </>
  );
};

export default ProceedToSignupModal;
